module.exports = __webpack_public_path__ + "img/rebel-ska.043a8a7b.png";